import styled from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
export var ProductName = styled(AppLink).withConfig({
  displayName: "ProductName",
  componentId: "sc-az119-0"
})(["display:block;overflow:hidden;height:66px;cursor:pointer;font-size:16px;font-weight:500;line-height:21px;white-space:normal;color:", ";span{color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.font;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.font;
});